import React from 'react';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import Icon from '../Common/Icon';
import Dockbar from '../Common/Dockbar/Dockbar';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import TaskResultMobile from './TaskResultMobile';
import { BaselineTaskItem, Option, BaselineOption } from '../../types/common';

import './BaselineTaskListMobile.scss';

// Additional interface for search params
interface SearchParams {
	baselineId: string | number;
	name: string;
	additionalInfo: string;
	departments: number[];
	baselineJobTitles: number[];
	communities: number[];
	phases: number[];
	disciplines: number[];
	tags: number[];
	isActive: boolean | null;
	pageSize: number;
	pageNumber: number;
	createdDateStart?: Date | string | null;
	createdDateEnd?: Date | string | null;
	sortBy?: string;
	sortDir?: string;
}

interface ComponentProps {
	baselines: BaselineOption[];
	baselineTasks: BaselineTaskItem[];
	isFetchingBaselines: boolean;
	isFetchingTasks: boolean;
	isLoadingBaselines: boolean;
	isLoadingTasks: boolean;
	updateParamsAndSearch: (name?: string, value?: any) => void;
	updateSearchParams: (name: string, value: any) => void;
	searchParams: SearchParams;
	showTask: (id?: number | null) => void;
	search: () => void;
	departments: Option[];
	baselineJobTitles: Option[];
	communities: Option[];
	phases: Option[];
	disciplines: Option[];
	onViewFiltersClick: () => void;
}

const BaselineTaskListMobile: React.FC<ComponentProps> = (props) => {
    const onBaselineSelected = (id: string | number): void => {
        props.updateParamsAndSearch("baselineId", id);
    };

    const onShowTask = (id: number | null): void => {
        props.showTask(id);
    };

    return (
        <div>
            {/* isLoadingBaselines (not isFetchingBaselines): the fetching flag would overlay a
                spinner on the whole page every time the list refetches on window refocus. */}
            <LoadingIndicator isLoading={props.isLoadingBaselines}>
                <div className="row no-gutters">
                    <div className="col baseline-mobile-task-list">
                        <div className="baseline-selector">
                            <MultiSelectBox
                                name="baselines"
                                label="Baselines"
                                options={props.baselines}
                                selectedValues={props.searchParams.baselineId.toString()}
                                idField="id"
                                valueField="name"
                                onChange={onBaselineSelected}
                                isMulti={false}
                            />
                        </div>
                        {/* isLoadingTasks (not isFetchingTasks): the latter is true on every
                            30s background poll, which would flash this spinner twice a minute. */}
                        <LoadingIndicator isLoading={props.isLoadingTasks}>
                            <div>
                                {props.baselineTasks.map((task: BaselineTaskItem) =>
                                    <TaskResultMobile key={task.id} task={task} showTask={onShowTask} />
                                )}
                                {props.baselineTasks.length === 0 ?
                                    <div className="ms-2">No Results Found</div>
                                :
                                ""
                                }
                            </div>
                        </LoadingIndicator>
                    </div>
                </div>
                <Dockbar>
                    <div className="container-fluid docked-content">
                        <button className="btn btn-light ms-2" onClick={props.onViewFiltersClick}><Icon name="filter" />View Filters</button> 
                        <button className="btn btn-primary float-end" onClick={() => onShowTask(null)}>Add Baseline Task</button>
                    </div>
                </Dockbar>
            </LoadingIndicator>
        </div>
    );
};

export default BaselineTaskListMobile;